<template>
    <v-col :sm="sm" :md="md" :lg="lg" :xl="xl" :cols="xs" ref="col" :class="widthClass" :style="style">
        <component-wrapper :config="component" />
    </v-col>
</template>

<script>
import components from '../component.js'
import Vue from 'vue'
export default {
    name: 'zoezi-column',

    zoezi: {
        title: 'Column',
        icon: 'mdi-table-column',
        type: 'sf'
    },

    watch: {
        '$vuetify.breakpoint.width': {
            immediate: true,
            handler() {
                Vue.nextTick(() => {
                    let width = this.$refs.col ? this.$refs.col.clientWidth : 0;
                    if (width == 0) {
                        this.widthClass = undefined;
                    } else if (width < 600) {
                        this.widthClass = 'zoezi-xs';
                    } else if (width < 960) {
                        this.widthClass = 'zoezi-sm';
                    } else if (width < 1264) {
                        this.widthClass = 'zoezi-md';
                    } else if (width < 1904) {
                        this.widthClass = 'zoezi-lg';
                    } else {
                        this.widthClass = 'zoezi-xl';
                    }
                });
            }
        }
    },

    props: {
        cols: {
            title: 'Width (1-12)',
            type: Number,
            typeinfo: {
                min: 1,
                max: 12,
            },
            default: 12,

        },
        cols_adv: {
            title: 'Advanced column settings',
            type: Object,
            fulltype: 'breakpointsetting',
        },
        padding: {
            title: 'Padding',
            type: String,
            fulltype: 'csssize',
            global: true
        },
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig()
        }
    },
    computed:{
        xs() {
            return this.cols_adv?.xs || 12;
        },
        sm() {
            return this.cols_adv?.sm;
        },
        md() {
            return this.cols_adv?.md || this.cols;
        },
        lg() {
            return this.cols_adv?.lg;
        },
        xl() {
            return this.cols_adv?.xl;
        },
        style() {
            if (this.padding) {
                return {padding: this.padding}
            }

            return null;
        }
    },
    data: () => ({
        widthClass: ''
    })
}
</script>
